// extracted by mini-css-extract-plugin
export var actionButton = "_ak-1";
export var actionButtons = "_ak-2";
export var actions = "_ak-0";
export var aiUnread = "_ak-10";
export var alignCenter = "_ak-h";
export var backWrapper = "_ak-3";
export var cellContainer = "_ak-4";
export var checkboxContainer = "_ak-5";
export var contentContainer = "_ak-6";
export var contentHeader = "_ak-8";
export var conversationsTableWrapper = "_ak-s";
export var draftReplyBadgeContainer = "_ak-m";
export var dropdownItem = "_ak-b";
export var dropdownItemsContainer = "_ak-a";
export var dropdownTitle = "_ak-c";
export var errorIcon = "_ak-7";
export var filter = "_ak-d";
export var gray = "_ak-i";
export var headerActionButtons = "_ak-e";
export var headerCheckboxContainer = "_ak-f";
export var icon = "_ak-j";
export var menuContainer = "_ak-k";
export var noMoreTicketsIcon = "_ak-12";
export var noMoreTicketsSubText = "_ak-13";
export var oneLine = "_ak-l";
export var optionsButton = "_ak-n";
export var plus = "_ak-o";
export var portalButtonsWrapper = "_ak-g";
export var red = "_ak-p";
export var scrolledTop = "_ak-9";
export var search = "_ak-q";
export var selectedConversationsCount = "_ak-r";
export var spinner = "_ak-t";
export var strong = "_ak-u";
export var summaryCell = "_ak-v";
export var tableContainer = "_ak-11";
export var tagContainer = "_ak-w";
export var threeDots = "_ak-x";
export var twoLines = "_ak-y";
export var unread = "_ak-z";